import classnames from "classnames";
import React, { useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectSubsidiaryAction } from "../../../store/slices/app/companySlice";
import { getEffectiveSubsidiary, getVisibleSubsidiaries } from "../../../utils/subsidiaryAccess";
import Msg from "../i18n/Msg";

const RecentObjects = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { subsidiaries, subsidiarySelected } = useSelector((state) => state.company);
  const { userInfo } = useSelector((state) => state.auth);
  const visibleSubsidiaries = useMemo(() => getVisibleSubsidiaries(subsidiaries, userInfo), [subsidiaries, userInfo]);
  const effectiveSubsidiary = useMemo(
    () => getEffectiveSubsidiary(subsidiaries, subsidiarySelected, userInfo),
    [subsidiaries, subsidiarySelected, userInfo]
  );

  useEffect(() => {
    if (effectiveSubsidiary?.uuid && effectiveSubsidiary.uuid !== subsidiarySelected?.uuid) {
      dispatch(selectSubsidiaryAction(effectiveSubsidiary));
    }
  }, [effectiveSubsidiary, subsidiarySelected, dispatch]);

  if (shouldHideRecentObjects(pathname)) {
    return null;
  }

  const onSelectSubsidiary = (e, subsidiary) => {
    e.preventDefault();
    dispatch(selectSubsidiaryAction(subsidiary));
  };

  return (
    <div className="project-context dropdown">
      <span className="label branch-label">
        <Msg phrase="Branch" />
      </span>
      <Dropdown as={"ul"} className={classnames("project-selector")}>
        <Dropdown.Toggle as={"a"} className={classnames("project-selector dropdown-toggle")}>
          <span>{effectiveSubsidiary?.name}&nbsp;</span>
          <i className="fa fa-angle-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu as="ul" className="dropdown-menu">
          {visibleSubsidiaries?.map((subsidiary) => (
            <Dropdown.Item as="li" key={subsidiary.uuid}>
              <a href="/" onClick={(e) => onSelectSubsidiary(e, subsidiary)}>
                {subsidiary.name}
              </a>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

const shouldHideRecentObjects = (pathname) => {
  const normalizedPath = (pathname || "").replace(/\/+$/, "");
  return normalizedPath.endsWith("/setting") || normalizedPath === "/timetable/teacher" || normalizedPath === "/teacher/info";
};

export default RecentObjects;
